import styled from 'astroturf/react'
import { useDeviceType } from '@calendly/ui/hooks/use-device-type'

import ZoomLogo from 'images/logos/zoom.svg'
import SalesforceLogo from 'images/logos/salesforce.svg'
import GoogleCalendarLogo from 'images/logos/google-calendar.svg'
import SlackLogo from 'images/logos/slack.svg'
import MsTeamsLogo from 'images/logos/ms-teams.svg'
import GoogleMailLogo from 'images/logos/google-mail.svg'
import MsOutlookLogo from 'images/logos/ms-outlook.svg'
import WebexLogo from 'images/logos/webex.svg'
import HubspotLogo from 'images/logos/hubspot.svg'
import LinkedinLogo from 'images/logos/linkedin.svg'
import StripeLogo from 'images/logos/stripe.svg'
import PaypalLogo from 'images/logos/paypal.svg'
import _IntegrationsGrid from "icons-IntegrationsGrid.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/marketing_banner/icons.js?styleId=IntegrationsGrid";
import _IntegrationIcon from "icons-IntegrationIcon.module.css!=!astroturf/inline-loader?style=1!/app/frontend/components/confirmation/pages/personalized_confirmation/marketing_banner/icons.js?styleId=IntegrationIcon";


const iconSize = '32px'

const integrationIcons = [
  'zoom',
  'salesforce',
  'google-calendar',
  'slack',
  'ms-teams',
  'google-mail',
  'ms-outlook',
  'webex',
  'hubspot',
  'linkedin',
  'stripe',
  'paypal',
]

const ICONS_FOR_KIND = {
  zoom: ZoomLogo,
  salesforce: SalesforceLogo,
  'google-calendar': GoogleCalendarLogo,
  slack: SlackLogo,
  'ms-teams': MsTeamsLogo,
  'google-mail': GoogleMailLogo,
  'ms-outlook': MsOutlookLogo,
  webex: WebexLogo,
  hubspot: HubspotLogo,
  linkedin: LinkedinLogo,
  stripe: StripeLogo,
  paypal: PaypalLogo,
}

const IntegrationsGrid = /*#__PURE__*/styled('div', null, {
  displayName: "IntegrationsGrid",
  styles: _IntegrationsGrid,
  attrs: props => ({
    ...props,
    isTabletDown: useDeviceType('isTabletDown'),
    isPhone: useDeviceType('isPhone')
  })
})

const IntegrationIcon = /*#__PURE__*/styled('div', null, {
  displayName: "IntegrationIcon",
  styles: _IntegrationIcon
})

export const Icons = () => (
  <IntegrationsGrid>
    {integrationIcons.map((iconName) => (
      <IntegrationIcon key={iconName}>
        <img src={ICONS_FOR_KIND[iconName]} alt={iconName} />
      </IntegrationIcon>
    ))}
  </IntegrationsGrid>

)
